import React, {Component} from 'react';
import {Modal, Button, Col}  from 'react-bootstrap'

export default class ModalFactory extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      errMsg: null,
    }
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {

  }

  async handleClose() {
    this.props.hide();
  }

  async handleSave() {
    const msg = this.props.validate();
    this.setState({errMsg: msg});
    if (null === msg) {
      const msg2 = await this.props.handleSave();
      this.setState({errMsg: msg2})
      if (!msg2)
        this.handleClose();
    }
  }

  inputBorder(valid) {
    return valid ? "input-ok" : "input-issue";
  }

  inputCommon (element, id, prompt) {
    return (
      <Col md="5" className="label-item">
        <label for={id}>{prompt} </label>
        {element}
      </Col>
    )
  }
  modalInput (id, prompt, valid=true, itype='text', inputSize=35) {
    const bcolor = this.inputBorder(valid);
    const prev_item = this.props.ff.findChange(id)
    const toDisplay = prev_item ? prev_item.value : ""
     return (
      this.inputCommon (
        <input className={"compact-item "+bcolor} type={itype} value={toDisplay} id={id} name={id} size={inputSize}
          onChange={this.props.handleChange} autoComplete="new-password" />, id, prompt
      )
    )
  }
  modalInputArr(arrInputs) {
    let result = [];
    arrInputs.forEach(element => {
      result.push (this.modalInput(element?.key, element?.label, element?.valid, element?.itype))     
    });
    return result;
  }
  renderHeader(title) {
    return (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )    
  }
  render() {
    const elements = this.modalInputArr(this.props.inputs)
    return(
      <Modal show={this.props.show} onHide={this.handleClose} size="lg">
        {this.renderHeader(this.props.header)}
        {React.cloneElement(this.props.children, {"elements": elements} )}
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" onClick={()=>this.handleClose()}>Cancel</Button>
          <Button className="custom-std-btn" onClick={()=>this.handleSave()}>Save</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}